import AdminLayout from './AdminLayout';

const AdminUsersPage = () => {
  return (
    <AdminLayout title="User Management">
      <div className="max-w-6xl">
        <div className="bg-white rounded-xl border border-slate-200/80 overflow-hidden">
          {/* Header with action button */}
          <div className="flex items-center justify-between p-6 border-b border-slate-200">
            <div>
              <h2 className="text-[15px] font-semibold text-slate-800">Users List</h2>
              <p className="text-[12px] text-slate-500 mt-1">Manage all registered users and their roles</p>
            </div>
            <button className="px-4 py-2 bg-blue-600 text-white text-[13px] font-medium rounded-lg hover:bg-blue-700 transition-colors">
              Add User
            </button>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full text-[13px]">
              <thead>
                <tr className="border-b border-slate-200 bg-slate-50">
                  <th className="px-6 py-3 text-left font-semibold text-slate-700">Name</th>
                  <th className="px-6 py-3 text-left font-semibold text-slate-700">Email</th>
                  <th className="px-6 py-3 text-left font-semibold text-slate-700">Role</th>
                  <th className="px-6 py-3 text-left font-semibold text-slate-700">Status</th>
                  <th className="px-6 py-3 text-left font-semibold text-slate-700">Joined</th>
                  <th className="px-6 py-3 text-left font-semibold text-slate-700">Actions</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { name: 'John Doe', email: 'john@example.com', role: 'Admin', status: 'Active', joined: '2024-01-15' },
                  { name: 'Jane Smith', email: 'jane@example.com', role: 'Moderator', status: 'Active', joined: '2024-02-20' },
                  { name: 'Mike Johnson', email: 'mike@example.com', role: 'User', status: 'Inactive', joined: '2024-03-01' },
                ].map((user, idx) => (
                  <tr key={idx} className="border-b border-slate-100 hover:bg-slate-50 transition-colors">
                    <td className="px-6 py-3 font-medium text-slate-800">{user.name}</td>
                    <td className="px-6 py-3 text-slate-600">{user.email}</td>
                    <td className="px-6 py-3">
                      <span className="px-2 py-1 rounded-full text-[12px] font-medium bg-blue-50 text-blue-600">
                        {user.role}
                      </span>
                    </td>
                    <td className="px-6 py-3">
                      <span
                        className={`px-2 py-1 rounded-full text-[12px] font-medium ${
                          user.status === 'Active'
                            ? 'bg-emerald-50 text-emerald-600'
                            : 'bg-slate-50 text-slate-600'
                        }`}
                      >
                        {user.status}
                      </span>
                    </td>
                    <td className="px-6 py-3 text-slate-600">{user.joined}</td>
                    <td className="px-6 py-3">
                      <button className="text-blue-600 hover:text-blue-700 text-[12px] font-medium mr-3">
                        Edit
                      </button>
                      <button className="text-red-600 hover:text-red-700 text-[12px] font-medium">Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Footer with pagination */}
          <div className="flex items-center justify-between p-4 border-t border-slate-200 bg-slate-50">
            <p className="text-[12px] text-slate-500">Showing 3 of 150 users</p>
            <div className="flex gap-2">
              <button className="px-3 py-1.5 border border-slate-200 rounded-lg text-[12px] font-medium text-slate-700 hover:bg-white transition-colors">
                Previous
              </button>
              <button className="px-3 py-1.5 border border-slate-200 rounded-lg text-[12px] font-medium text-slate-700 hover:bg-white transition-colors">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminUsersPage;
